import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "flex items-center justify-center py-8"
};
const _hoisted_2 = {
    key: 1,
    class: "flex flex-col"
};
const _hoisted_3 = {
    key: 0,
    class: "flex items-center justify-center py-8"
};
const _hoisted_4 = {
    key: 1,
    class: "flex flex-col"
};
import { computed, ref } from "vue";
import { useI18n } from "vue-i18n";
import { Button, TextLink, Dropdown, WidgetShell } from "@eudonet/opal";
import { useHousehold } from "../../composables/useHousehold";
import ModuleState from "@/shared/components/ModuleState.vue";
import ContactActiveRelationRow from "./ContactActiveRelationRow.vue";
import ContactActiveHouseholdRow from "./ContactActiveHouseholdRow.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ContactActiveRelationsWidget',
    props: {
        contactId: {},
        relations: {},
        relationsLoading: { type: Boolean },
        relationsLoadError: { type: Boolean }
    },
    emits: ["navigate-to-relations", "reload-relations"],
    setup(__props) {
        const props = __props;
        const { t } = useI18n();
        const viewMode = ref("organisations");
        // ─── Organisations data (from parent props) ─────────────────────────────────────
        const activeFunctions = computed(() => {
            if (!props.relations)
                return [];
            return props.relations.organisations.flatMap((org) => org.functions
                .filter((fn) => fn.isCurrent)
                .map((fn) => ({ fn, org: { id: org.id, name: org.name, logoUrl: org.logoUrl } })));
        });
        // ─── Foyer data ────────────────────────────────────────────────────────────────
        const { household, loading: householdLoading, loadError: householdLoadError, load: loadHousehold, reload: reloadHousehold, } = useHousehold(() => props.contactId);
        const householdMembers = computed(() => household.value?.members ?? []);
        // ─── View switcher ─────────────────────────────────────────────────────────────
        const currentViewLabel = computed(() => viewMode.value === "organisations"
            ? t("contact.detail.relations.widget.view.organisations")
            : t("contact.detail.relations.widget.view.foyer"));
        const footerLabel = computed(() => viewMode.value === "organisations"
            ? t("contact.detail.relations.widget.orgs.historyLink")
            : t("contact.detail.relations.widget.foyer.historyLink"));
        function switchView(mode) {
            viewMode.value = mode;
            if (mode === "foyer" && !household.value && !householdLoading.value) {
                loadHousehold();
            }
        }
        const viewItems = computed(() => [
            {
                label: t("contact.detail.relations.widget.view.organisations"),
                active: viewMode.value === "organisations",
                onClick: () => switchView("organisations"),
            },
            {
                label: t("contact.detail.relations.widget.view.foyer"),
                active: viewMode.value === "foyer",
                onClick: () => switchView("foyer"),
            },
        ]);
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(WidgetShell), {
                header: _ctx.$t('contact.detail.relations.widget.title')
            }, {
                actions: _withCtx(() => [
                    _createVNode(_unref(Dropdown), {
                        items: viewItems.value,
                        "menu-align": "right"
                    }, {
                        trigger: _withCtx(({ triggerProps }) => [
                            _createVNode(_unref(TextLink), _mergeProps(triggerProps, { "icon-right": "ri-arrow-down-s-line" }), {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(currentViewLabel.value), 1 /* TEXT */)
                                ]),
                                _: 1 /* STABLE */
                            }, 16 /* FULL_PROPS */)
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["items"])
                ]),
                footer: _withCtx(() => [
                    _createVNode(_unref(Button), {
                        variant: "secondary",
                        size: "sm",
                        "icon-left": "ri-eye-line",
                        label: footerLabel.value,
                        onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.$emit('navigate-to-relations', viewMode.value)))
                    }, null, 8 /* PROPS */, ["label"])
                ]),
                default: _withCtx(() => [
                    (viewMode.value === 'organisations')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            (__props.relationsLoading)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[2] || (_cache[2] = [
                                        _createElementVNode("i", {
                                            class: "ri-loader-4-line animate-spin text-3xl text-(--text-text-disabled-strong)",
                                            "aria-hidden": "true"
                                        }, null, -1 /* CACHED */)
                                    ]))]))
                                : (__props.relationsLoadError)
                                    ? (_openBlock(), _createBlock(ModuleState, {
                                        key: 1,
                                        type: "error",
                                        title: _ctx.$t('contact.detail.relations.widget.loadError.title'),
                                        "cta-icon": "ri-refresh-line",
                                        "cta-label": _ctx.$t('contact.detail.relations.widget.loadError.retry'),
                                        onCta: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('reload-relations')))
                                    }, null, 8 /* PROPS */, ["title", "cta-label"]))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                        (activeFunctions.value.length === 0)
                                            ? (_openBlock(), _createBlock(ModuleState, {
                                                key: 0,
                                                type: "empty",
                                                title: _ctx.$t('contact.detail.relations.widget.orgs.empty'),
                                                description: _ctx.$t('contact.detail.relations.widget.orgs.emptyDescription')
                                            }, null, 8 /* PROPS */, ["title", "description"]))
                                            : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activeFunctions.value, (item) => {
                                                    return (_openBlock(), _createBlock(ContactActiveRelationRow, {
                                                        key: item.fn.id,
                                                        fn: item.fn,
                                                        org: item.org
                                                    }, null, 8 /* PROPS */, ["fn", "org"]));
                                                }), 128 /* KEYED_FRAGMENT */))
                                            ]))
                                    ], 64 /* STABLE_FRAGMENT */))
                        ], 64 /* STABLE_FRAGMENT */))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            (_unref(householdLoading))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [...(_cache[3] || (_cache[3] = [
                                        _createElementVNode("i", {
                                            class: "ri-loader-4-line animate-spin text-3xl text-(--text-text-disabled-strong)",
                                            "aria-hidden": "true"
                                        }, null, -1 /* CACHED */)
                                    ]))]))
                                : (_unref(householdLoadError))
                                    ? (_openBlock(), _createBlock(ModuleState, {
                                        key: 1,
                                        type: "error",
                                        title: _ctx.$t('contact.detail.relations.widget.loadError.title'),
                                        "cta-icon": "ri-refresh-line",
                                        "cta-label": _ctx.$t('contact.detail.relations.widget.loadError.retry'),
                                        onCta: _unref(reloadHousehold)
                                    }, null, 8 /* PROPS */, ["title", "cta-label", "onCta"]))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                        (householdMembers.value.length === 0)
                                            ? (_openBlock(), _createBlock(ModuleState, {
                                                key: 0,
                                                type: "empty",
                                                title: _ctx.$t('contact.detail.relations.widget.foyer.empty'),
                                                description: _ctx.$t('contact.detail.relations.widget.foyer.emptyDescription')
                                            }, null, 8 /* PROPS */, ["title", "description"]))
                                            : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(householdMembers.value, (member) => {
                                                    return (_openBlock(), _createBlock(ContactActiveHouseholdRow, {
                                                        key: member.id,
                                                        member: member
                                                    }, null, 8 /* PROPS */, ["member"]));
                                                }), 128 /* KEYED_FRAGMENT */))
                                            ]))
                                    ], 64 /* STABLE_FRAGMENT */))
                        ], 64 /* STABLE_FRAGMENT */))
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["header"]));
        };
    }
});
